module.exports = __webpack_public_path__ + "img/come-vict-10.5c472b25.jpg";